import React from 'react';
import { Input, Space, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;
const { Title } = Typography;

/**
 * Arşivlenmiş formlar sayfa başlığı ve arama alanı
 */
const PageHeader = ({ 
  searchText, 
  onSearchChange, 
  totalCount = 0 
}) => {
  return (
    <div style={{ marginBottom: 24 }}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Title level={2} style={{ margin: 0 }}>
          Arşivlenmiş Formlar
          {totalCount > 0 && (
            <span style={{ 
              fontSize: '14px', 
              fontWeight: 'normal', 
              color: '#666',
              marginLeft: 8 
            }}>
              ({totalCount} form)
            </span>
          )}
        </Title>
        
        <Search
          placeholder="Form adı, açıklama veya kategori ile ara..."
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ maxWidth: 400 }}
          prefix={<SearchOutlined />}
          allowClear
        />
      </Space>
    </div>
  );
};

export default PageHeader;
